import api from '@/api';

const { $pricing, $academic } = api;

export const { $types, $products, $zones, $discounts } = $pricing;
export const { $careers } = $academic;
